import script from "./InputWithPop.vue?vue&type=script&setup=true&lang=js"
export * from "./InputWithPop.vue?vue&type=script&setup=true&lang=js"

import "./InputWithPop.vue?vue&type=style&index=0&id=203bd4c5&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-203bd4c5"]])

export default __exports__